import { Button, Card, Col, DatePicker, Form, Input, Modal, Row, message } from "antd";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";
import dayjs from "dayjs";
import ContactInput from "../../components/ContactInput";

function UserEdit({ editData, isLoading, onClose, fetchList, type }) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (editData) {
      const fields = {
        fullname: editData?.fullname,
        email: editData?.email,
        phoneNo: editData?.phoneNumber,
        dob: editData?.dob ? dayjs(editData.dob, "DD-MM-YYYY") : null,
        password: editData?.password,
        city: editData?.city === "-" ? "" : editData?.city,
        state: editData?.state === "-" ? "" : editData?.state,
        country: editData?.country === "-" ? "" : editData?.country,
      };

      if (editData.productName === "PG Platinum") {
        editData.accountDetails?.forEach((acc, index) => {
          fields[`brokerName${index}`] = acc?.brokerName;
          fields[`balance${index}`] = acc?.balance;
          fields[`accountName${index}`] = acc?.accountName;
          fields[`accountNumber${index}`] = acc?.accountNumber;
          fields[`investorPassword${index}`] = acc?.investorPassword;
          fields[`brokerServer${index}`] = acc?.brokerServer;
        });
      } else {
        const acc = editData.accountDetails?.[0] || {};
        fields.brokerName = acc.brokerName === "-" ? "" : acc.brokerName;
        fields.balance = acc.balance === "-" ? "" : acc.balance;
        fields.accountName = acc.accountName === "-" ? "" : acc.accountName;
        fields.accountNumber = acc.accountNumber === "-" ? "" : acc.accountNumber;
        fields.investorPassword = acc.investorPassword === "-" ? "" : acc.investorPassword;
        fields.brokerServer = acc.brokerServer === "-" ? "" : acc.brokerServer;
      }

      form.setFieldsValue(fields);
    }
  }, [editData]);

  const formSubmit = (val) => {
    let payload = {
      fullName: val.fullname || undefined,
      email: val.email || undefined,
      password: val.password || undefined,
      phoneNumber: val.phoneNo || undefined,
      city: val.city || undefined,
      state: val.state || undefined,
      country: val.country || undefined,
      dob: val.dob || undefined,
    };

    if (editData?.productName === "PG Platinum") {
      payload.accountDetails = editData.accountDetails
        ?.map((acc, index) => {
          const accountData = {
            accountName: val[`accountName${index}`] || undefined,
            accountNumber: val[`accountNumber${index}`] || undefined,
            balance: val[`balance${index}`] || undefined,
            brokerName: val[`brokerName${index}`] || undefined,
            brokerServer: val[`brokerServer${index}`] || undefined,
            investorPassword: val[`investorPassword${index}`] || undefined,
            productName: acc.productName || editData.productName || undefined,
          };

          Object.keys(accountData).forEach((key) => {
            if (!accountData[key] && accountData[key] !== 0) delete accountData[key];
          });

          return accountData;
        })
        .filter((acc) => Object.keys(acc).length > 0);
    } else {
      payload.accountDetails = [
        {
          accountName: val.accountName || undefined,
          accountNumber: val.accountNumber || undefined,
          balance: val.balance || undefined,
          brokerName: val.brokerName || undefined,
          investorPassword: val.investorPassword || undefined,
          brokerServer: val.brokerServer || undefined,
          productName: editData.productName || undefined,
        },
      ];
    }

    payload = Object.fromEntries(Object.entries(payload).filter(([_, v]) => v !== undefined));

    axios
      .put(`${process.env.REACT_APP_ADMIN_API_URL}admin/edit-user/${editData?.key}`, payload, {
        headers: { "x-product-type": "PIP_GRID" },
      })
      .then(() => {
        message.success("User updated successfully!");
        onClose();
        form.resetFields();
        fetchList();
      })
      .catch(() => message.error("Something went wrong"));
  };

  return (
    <Modal open={true} title="Edit User" onCancel={onClose} footer={null}>
        <div className="user-edit-modal">
        <Form form={form} layout="vertical" onFinish={formSubmit}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Full Name" name="fullname" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <ContactInput form={form} name="phoneNo" label="Phone Number" require disabled />
            </Col>
            <Col span={24}>
              <Form.Item label="Email" name="email" rules={[{ required: true, type: "email" }]}>
                <Input readOnly />
              </Form.Item>
            </Col>
            {type === "list" && (
              <Col span={12}>
                <Form.Item label="Password" name="password" rules={[{ required: true }]}>
                  <Input.Password />
                </Form.Item>
              </Col>
            )}
            <Col span={12}>
              <Form.Item label="Date of Birth" name="dob" rules={[{ required: true }]}>
                <DatePicker format="DD-MM-YYYY" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="City" name="city" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="State" name="state" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Country" name="country" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
            </Col>
            {type !== "request" &&
              (editData?.productName === "PG Platinum" ? (
                editData?.accountDetails?.map((acc, index) => (
                  <React.Fragment key={index}>
                    <Col span={24} style={{ paddingBottom: "10px" }}>
                      <h3>
                        MT5 Account Detail - {index + 1} ({acc?.productName})
                      </h3>
                    </Col>
                    <Col span={12}>
                      <Form.Item label="Account Name" name={`accountName${index}`}>
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item label="Account Number" name={`accountNumber${index}`}>
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item label="Balance" name={`balance${index}`}>
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item label="Broker Name" name={`brokerName${index}`}>
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item label="Broker Server" name={`brokerServer${index}`}>
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item label="Investor Password" name={`investorPassword${index}`}>
                        <Input.Password />
                      </Form.Item>
                    </Col>
                  </React.Fragment>
                ))
              ) : (
                <>
                  <Col span={24} style={{ paddingBottom: "10px" }}>
                    <h3>MT5 Account Detail</h3>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="Account Name" name="accountName">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="Account Number" name="accountNumber">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="Balance" name="balance">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="Broker Name" name="brokerName">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="Broker Server" name="brokerServer">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="Investor Password" name="investorPassword">
                      <Input.Password />
                    </Form.Item>
                  </Col>
                </>
              ))}
          </Row>
          <Button type="primary" htmlType="submit" loading={isLoading}>
            Save Changes
          </Button>
        </Form>
    </div>
      </Modal>
  );
}

const mapStateToProps = ({ loading }) => ({ isLoading: loading.isLoading });
export default connect(mapStateToProps, {})(UserEdit);
